import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@bcc/components/ui/dialog";
import type { ApprovalStatusResponseRecord } from "@shared/services/salesforce/types";
import { useTranslation } from "react-i18next";
import { setPendingRequestsModalRowTestId, setPendingRequestsModalTestId } from "../products-table.utils";

interface PendingRequestsModalProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly requests: ApprovalStatusResponseRecord[];
}

export const PendingRequestsModal = ({ open, onOpenChange, requests }: PendingRequestsModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent testId={setPendingRequestsModalTestId()}>
        <DialogHeader>
          <DialogTitle>{t("views.productsTable.requests.modal.title")}</DialogTitle>
          <DialogDescription className="sr-only">{t("views.productsTable.requests.modal.title")}</DialogDescription>
        </DialogHeader>
        {requests.length === 0 ? (
          <p className="py-4 text-center text-sm text-muted-foreground">{t("views.productsTable.requests.modal.empty")}</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b">
                  <th className="pb-2 text-left font-medium text-muted-foreground">{t("views.productsTable.requests.modal.requestId")}</th>
                  <th className="pb-2 text-left font-medium text-muted-foreground">{t("views.productsTable.requests.modal.actionType")}</th>
                  <th className="pb-2 text-left font-medium text-muted-foreground">{t("views.productsTable.requests.modal.status")}</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((request, index) => (
                  <tr key={request.Id} data-testid={setPendingRequestsModalRowTestId(index)} className="border-b last:border-0">
                    <td className="py-3 pr-4 font-mono text-xs">{request.Name}</td>
                    <td className="py-3 pr-4">{request.Performed_Action__c}</td>
                    <td className="py-3">
                      <ApprovalStatusBadge status={request.Approval_status__c} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

const ApprovalStatusBadge = ({ status }: { status: string }) => {
  const isApproved = status === "Approved";
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
        isApproved ? "bg-green-500/10 text-green-700 dark:text-green-400" : "bg-blue-500/10 text-blue-700 dark:text-blue-400"
      }`}
    >
      {status}
    </span>
  );
};
